const options = {
  5: "bg-blue-100/5",
  10: "bg-blue-100/10",
  25: "bg-blue-100/25",
  50: "bg-blue-100/50",
  75: "bg-blue-100/75",
  90: "bg-blue-100/90",
  100: "bg-blue-100",
};

const from = {
  5: "from-blue-100/5",
  10: "from-blue-100/10",
  25: "from-blue-100/25",
  50: "from-blue-100/50",
  75: "from-blue-100/75",
  90: "from-blue-100/90",
  100: "from-blue-100",
};

export default function getBackgroundBlue100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
